import { render } from "./TwoFA.vue?vue&type=template&id=2663db6b"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__